import React from "react";

import styled from "styled-components";
import formatConverter from "../../../../helper/formatConverter";
import { formatShipmentDate, normalizeShipmentListItem } from "../../../../helper/shipment/safeShipmentListItem";
import { useEffect } from "react";
import Btn from "../../../shared/button/Btn";
import { showModal } from "../../../../features/modal/modalSlice";
import { useDispatch } from "react-redux";
import yayinlamaSecenekleriOptions from "../../../../utils/yukOptions/yayinlamaSecenekleriOptions";
import moment from "moment";
import { setLoadItemData } from "../../../../features/loadList/loadListSlice";
import { clearUserState } from "../../../../features/user/userSlice";
import getGivenDatePlusHours from "../../../../helper/date/getGivenDatePlusHours";
import CopyableShipmentValue from "../../../shipmentOperation/CopyableShipmentValue";
import { wideShipmentCardStyles } from "../../../shipmentOperation/shipmentCardStyles";

const Container = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 30px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  border-radius: 10px;
  color: ${({ theme }) => theme.mainTextColor};
  cursor: pointer;

  .content-side{
    display: flex;
    justify-content: space-between;
    position: relative;
    width: calc(100% - 450px);
    margin: 20px;
    min-height: 300px;

    .more-icon {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 1.6rem;
      fill: ${({ theme }) => theme.mainTextColor};
      cursor: pointer;
    }


    .column-container{
      width: calc(33% - 10px);
      display: flex;
      flex-direction: column;
      gap: 30px;

      .column-item{
        display: flex;
        flex-direction: column;
        width: 100%;
        min-height: 160px;

        .column-item-title{
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-xl);
          margin-bottom: 10px;
          color: var(--color-main);
          border-bottom: 1px solid var(--color-main);
        }

        .content-item{
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          padding-bottom: 8px;
        }

        .text-sm{
          font-size: 12px;
        }


        .route-list {
          display: flex;
          flex-direction: column;
          margin-bottom: 20px;

          .content-item {
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            padding-bottom: 8px;
            .date-error{
              color: var(--color-main);
              font-weight: var(--font-weight-md);
              font-size: var(--font-size-xs);
              animation: fade 1s infinite;
          }
          }

          .seperator {
            border-top: 1px solid ${({ theme }) => theme.mainTextColor};
          }

          .bold {
            font-weight: var(--font-weight-lg);
            text-decoration: underline;
          }
        }


      }


    }
    
  }
  @keyframes fade {
      0%, 100% {
          opacity: 1;
      }
      50% {
          opacity: 0.5;
      }
  }
  /* .input-side {
    width: calc(100% - 450px);
    margin: 20px;
    margin-right: 0;
    min-height: 300px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    position: relative;

    .more-icon {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 1.6rem;
      fill: ${({ theme }) => theme.mainTextColor};
      cursor: pointer;
    }

    .content-group {
      display: flex;
      flex-direction: column;
      width: 33%;

      .title {
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-xl);
        margin-bottom: 10px;
        color: var(--color-main);
        padding: 0 10px;
      }

      .content-list {
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 0 10px;

        .content-item {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
        }
      }

      .route-list {
        display: flex;
        flex-direction: column;
        padding: 0 10px;
        margin-bottom: 20px;
        gap: 5px;

        .content-item {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
        }

        .seperator {
          border-top: 1px solid ${({ theme }) => theme.mainTextColor};
        }

        .bold {
          font-weight: var(--font-weight-lg);
          text-decoration: underline;
        }
      }
    }

    .first-group {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .content-group-route {
      display: flex;
      flex-direction: column;
      width: 33%;
    }
  } */

  .map-side {
    width: 450px;
    margin: 20px;
    min-height: 300px;
    display: flex;
    flex-direction: column;
    /* border: 1px solid ${({ theme }) => theme.mainTextColor}; */
    border-radius: 10px;

    .map-container {
      width: 100%;
      height: 470px;
      border-radius: 10px;
    }

    .btn-container {
      width: 100%;
      height: 70px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  @media (max-width: 1500px){
    .content-side{
      .more-icon {
        right: 0;
        top: -10px !important;
      }
    }
    
    .map-side {
      width: 350px;
      min-height: 200px;
      .map-container {
        height: 400px;
      }

      .btn-container {
        gap: 10px;
      }
    }
  }

  @media (max-width: 1150px){
    .content-side{
      width: 100%;
    }
  }

  ${wideShipmentCardStyles}
`;

const ItemContainerWide = ({
  item: sourceItem,
  activeItemId,
  setActiveItemId,
  forwardRef,
  handleClick,
}) => {
  const item = normalizeShipmentListItem(sourceItem);
  const dispatch = useDispatch();
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
  const rld = JSON.parse(storage.getItem("rld"))

  useEffect(() => {
    dispatch(clearUserState());
  }, []);

  useEffect(() => {
    if (activeItemId === item.id) {
      handleClick(item.id);
    }
  }, [activeItemId]);

  const isNotYukveren = (rld === "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84") || (rld === "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228")
  
  const now = moment();
  const loadDateValue = item.routePoints.$values[0]?.loadDate;
  const loadDate = loadDateValue ? moment(loadDateValue) : null;
  
  const isPast = loadDate?.isValid() ? loadDate.isBefore(now, 'day') : false;
  

  const handleMouseUp = () => {
    const selection = window.getSelection();
    if (selection && selection.toString().length > 0) {
      // Burada gerekli kontrolleri yapabilirsiniz.
    }
  };

  return (
    <Container
      activeItem={item.id === activeItemId}
      onClick={() => {
        handleClick(item.id);
        window.getSelection().toString().length < 1 && setActiveItemId(activeItemId === item.id ? null : item.id);
      }}
      ref={forwardRef}
    >
      <CopyableShipmentValue className="absolute-id" label="ID" value={item.id} />
      <div className="content-side" onMouseUp={handleMouseUp}>
        {/* <MdOutlineMoreHoriz className="more-icon" /> */}

        <div className="column-container">
          <div className="column-item">
            <h3 className="column-item-title">Ödeme</h3>
            <div className="content-item">
              {formatConverter(item.freight, 0)}{" "}
              {item.paymentUnit === 0 ? "TL/Komple" : "TL/Ton"}{" "}
                <span className="text-sm">{!isNotYukveren && `(Hedef Fiyatınız ${item.freightVisibility ? "Yayınlanıyor" : "Yayınlanmıyor" })`}</span>
            </div>
            {!isNotYukveren && 
              <div className="content-item">{formatConverter(item.loadOwnerFreight, 0)} {item.paymentUnit === 0 ? "TL/Komple" : "TL/Ton"}  <span className="text-sm">(Yük Veren Fiyatı)</span></div>
            }

            <div className="content-item">{item.paymentType}</div>
            {item.fuelPaymentId > 0 && (
              <div className="content-item">
                Yakıt{" "}
                {item.fuelPaymentId === 1
                  ? `%${item.fuelPayment}`
                  : item.fuelPaymentId === 2 && `${item.fuelPayment} TL`}
              </div>
            )}
            {item.commissionPaymentId > 0 && (
              <div className="content-item">
                Komisyon{" "}
                {item.commissionPaymentId === 1
                  ? `%${item.commissionPayment}`
                  : item.commissionPaymentId === 2 &&
                    `${item.commissionPayment} TL`}
              </div>
            )}
          </div>

          <div className="column-item">
          <h3 className="column-item-title">Yükleme</h3>
          {item.routePoints.$values
            .filter((item) => item.loadOrUnload === 0)
            .map((routeItem, i) => (
              <div className="route-list">
                <div className="content-item">
                  {formatShipmentDate(routeItem.loadDate, value => moment(value).format("DD.MM.YYYY"))}{" "}
                  {routeItem.loadTime}
                  {isPast && <p className="date-error">Tarihi geçti, yükünüz yayınlanmıyor!</p> }
                </div>
                <div className="content-item bold">
                  {i + 1}. {routeItem.displayName}
                </div>
                <div className="content-item">{routeItem.location}</div>
                <div className="content-item">{routeItem.address}</div>
                <div className="content-item">
                  {routeItem.loadMethods.$values.length > 0 ? routeItem.loadMethods.$values.map((item) => `${item.name} `) : "---"}
                </div>
                <div className="content-item">
                  {routeItem.displayName}
                </div>
                <div className="content-item">
                  {routeItem.routePointPersonName}
                </div>
                <div className="content-item">
                  {routeItem.routePointPersonPhoneNumber}
                </div>
                {item.routePoints.$values.filter(
                  (item) => item.loadOrUnload === 0
                )?.length !==
                  i + 1 && <div className="seperator" />}
              </div>
            ))}
          </div>
        </div>

        <div className="column-container">
          <div className="column-item">
            <div className="column-item-title">Yük</div>
            {item.senderName &&
              <div className="content-item">{item.senderName}</div>
            }
            <div className="content-item">
              {item.isParsiyel ? "LTL(Parsiyel)" : "FTL(Komple Araç)"}
            </div>
             <CopyableShipmentValue className="copy-field" label="Konteyner No" value={item.containerNumber} />
             <CopyableShipmentValue className="copy-field" label="Mühür No" value={item.sealNumber} />
             <CopyableShipmentValue className="copy-field" label="Firma Sevk. No" value={item.companyLoadNumber} />
            {item.LoadUnitId === 3 ? (
                <div className="content-item">
                  Basar Tonaj{" "}
                  {item.loadBulk > 0 &&
                    ` - ${item.loadBulk} ${item.loadBulk > 0 && "m3"}`}
                </div>
              ) : (
                <div className="content-item">
                  {item.loadQuantity} {item.loadUnit}{" "}
                  {item.loadBulk > 0 &&
                    ` - ${item.loadBulk} ${item.loadBulk > 0 && "m3"}`}
                </div>
              )}
              <div className="content-item">{item.loadType}</div>
              <div className="content-item">{item.loadDescription}</div>
          </div>

          <div className="column-item">
          <div className="column-item-title">Boşaltma</div>
            {item.routePoints.$values
              .filter((item) => item.loadOrUnload === 1)
              .map((routeItem, i) => (
                <div className="route-list">
                  <div className="content-item">
                    {formatShipmentDate(routeItem.loadDate, value => moment(value).format("DD.MM.YYYY"))}{" "}
                    {routeItem.loadTime}
                  </div>
                  <div className="content-item bold">{i + 1}. {routeItem.displayName}</div>
                  <div className="content-item">{routeItem.location}</div>
                  <div className="content-item">{routeItem.address}</div>
                  <div className="content-item">{routeItem.loadMethods.$values.length > 0 ? routeItem.loadMethods.$values.map((item) => `${item.name} `) : "---"}</div>
                  <div className="content-item">
                    {routeItem.displayName}
                  </div>
                  <div className="content-item">
                    {routeItem.routePointPersonName}
                  </div>
                  <div className="content-item">
                    {routeItem.routePointPersonPhoneNumber}
                  </div>
                  {item.routePoints.$values.filter(
                    (item) => item.loadOrUnload === 1
                  )?.length !==
                    i + 1 && <div className="seperator" />}
                </div>
              ))}
          </div>
        </div>
        <div className="column-container">
          <div className="column-item">
          <div className="column-item-title">Araç</div>
            <div className="content-item">{item.truckQuantity}{item.suppliedTruckQuantity && `/${item.suppliedTruckQuantity}`} Adet</div>
            <div className="content-item">
              {item.truckType} {item.trailerType}
            </div>
            <div className="content-item">{item.groundType}</div>
          </div>

          <div className="column-item">
            <div className="column-item-title">Diğer Bilgiler</div>
            <div className="content-item">
              {item.companyName}
            </div>
            <div className="content-item">
                {
                  yayinlamaSecenekleriOptions?.find(
                    (yItem) => yItem?.id === item?.publishingTypeId
                  )?.text
                }
            </div>
            {
                    item?.publishingTypeId === 2 &&
                    <div className="content-item">Yükün Herkese Yayınlanma Tarihi: {getGivenDatePlusHours(3 , item?.scheduledPublishTime.slice(0, -1))?.formattedDate} {getGivenDatePlusHours(3, item?.scheduledPublishTime.slice(0, -1))?.formattedTime}</div>
                }
              <div className="content-item">
                {formatConverter(item.distance, 0)} Km
              </div>
              <div className="content-item">{item?.projectName}</div>
          </div>
        </div>

        
      </div>
        <div className="wide-actions" onClick={(e) => e.stopPropagation()}>
            <Btn
              bgColor="#E85546"
              color="#fff"
              width={"auto"}
              padding="0 20px"
              borderColor="transparent"
              handleClick={() => {
                dispatch(setLoadItemData(item));
                dispatch(showModal("loadYetkiliBilgiForm"));
              }}
            >
              Yetkili Bilgileri Gir
            </Btn>
            {
              (rld !== "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" && rld !== "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228") &&
              <Btn
                bgColor="#E85546"
                color="#fff"
                width={"auto"}
                padding="0 20px"
                borderColor="transparent"
                handleClick={() => {
                  dispatch(setLoadItemData(item));
                  dispatch(showModal("updateLoad"));
                }}
              >
                Yükü Güncelle
              </Btn>
            }

            {
              (rld !== "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" && rld !== "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228") &&
              <Btn
              bgColor="#E85546"
              color="#fff"
              width={"auto"}
              padding="0 20px"
              borderColor="transparent"
              handleClick={() => {
                dispatch(setLoadItemData(item));
                dispatch(showModal("deleteLoadPermission"));
              }}
              >
                Yükü Sil
              </Btn>
            }
        </div>
    </Container>
  );
};

export default ItemContainerWide;
